/**
 * Has to start with `+`, then between 7 and 15 digits; spaces not allowed
 * @see https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s03.html
 */
export const phoneNumberPattern = /^\+?(?:[0-9]){4,14}[0-9]$/;
export const geolocationPattern =
  /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/;
